// Le Temple — Theme JS
'use strict';

// ===== CART =====
const Cart = {
  drawerEnabled: document.body.dataset.cartDrawer === 'true',
  drawer: null,
  overlay: null,
  countEl: null,

  init() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.countEl = document.querySelectorAll('.cart-count-badge');
    document.getElementById('cart-overlay')?.addEventListener('click', () => this.close());
    document.querySelectorAll('[data-open-cart]').forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      if (this.drawerEnabled) this.open();
      else window.location.href = '/cart';
    }));
    document.querySelectorAll('[data-close-cart]').forEach(btn => btn.addEventListener('click', () => this.close()));
  },

  open() {
    this.fetch().then(() => {
      this.drawer?.classList.add('open');
      this.overlay?.classList.add('visible');
      document.body.style.overflow = 'hidden';
      this.drawer?.removeAttribute('aria-hidden');
    });
  },

  close() {
    this.drawer?.classList.remove('open');
    this.overlay?.classList.remove('visible');
    document.body.style.overflow = '';
    this.drawer?.setAttribute('aria-hidden', 'true');
  },

  async fetch() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch(e) { console.error(e); }
  },

  render(cart) {
    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    const countSpan = document.getElementById('cart-drawer-count');
    if (!body) return;
    this.updateCount(cart.item_count);
    if (countSpan) countSpan.textContent = `(${cart.item_count})`;

    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
        <p style="margin-bottom:16px;">Votre panier est vide</p>
        <a href="/collections/all" class="btn btn-outline">Voir nos sacs</a>
      </div>`;
      if (footer) footer.style.display = 'none';
      return;
    }

    if (footer) footer.style.display = '';

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line="${item.key}">
        <div class="cart-item-img">
          <img src="${item.image ? item.image.replace(/\.jpg/, '_160x.jpg').replace(/\.png/, '_160x.png') : ''}" alt="${item.product_title}" loading="lazy">
        </div>
        <div class="cart-item-info">
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-qty">
            <button class="cart-item-qty-btn" data-action="decrease" data-line="${item.key}">−</button>
            <span class="cart-item-qty-num">${item.quantity}</span>
            <button class="cart-item-qty-btn" data-action="increase" data-line="${item.key}">+</button>
          </div>
          <span class="cart-remove" data-remove="${item.key}">Retirer</span>
        </div>
        <div class="cart-item-price">${this.formatMoney(item.final_line_price)}</div>
      </div>`).join('');

    if (footer) footer.innerHTML = `
      <div class="cart-subtotal">
        <span class="cart-subtotal-label">Sous-total</span>
        <span class="cart-subtotal-amount">${this.formatMoney(cart.total_price)}</span>
      </div>
      <p class="cart-shipping-note">Taxes calculées à la commande</p>
      <a href="/checkout" class="btn btn-gold btn-full btn-lg">Passer la commande</a>
      <a href="/cart" class="btn btn-outline btn-full" style="margin-top:8px;">Voir le panier</a>`;

    // Events (once to avoid duplicate listeners)
    body.addEventListener('click', e => {
      const dec = e.target.closest('[data-action="decrease"]');
      const inc = e.target.closest('[data-action="increase"]');
      const rem = e.target.closest('[data-remove]');
      if (dec) this.updateQty(dec.dataset.line, -1);
      if (inc) this.updateQty(inc.dataset.line, 1);
      if (rem) this.removeItem(rem.dataset.remove);
    }, {once: true});
  },

  async updateQty(key, delta) {
    const el = document.querySelector(`.cart-item[data-line="${key}"] .cart-item-qty-num`);
    const newQty = Math.max(0, (parseInt(el?.textContent) || 1) + delta);
    await this.changeItem(key, newQty);
  },

  async removeItem(key) { await this.changeItem(key, 0); },

  async changeItem(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      });
      const cart = await res.json();
      this.render(cart);
    } catch(e) { console.error(e); }
  },

  async addItem(variantId, qty = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variantId, quantity: qty, properties})
      });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Erreur'); }
      await this.fetch();
      if (this.drawerEnabled) this.open();
      Toast.show('Produit ajouté au panier ✓', 'success');
    } catch(e) {
      Toast.show(e.message || 'Impossible d\'ajouter ce produit', 'error');
    }
  },

  updateCount(count) {
    this.countEl.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  },

  formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', {style:'currency', currency:'EUR'});
  }
};

// ===== HEADER =====
const Header = {
  el: null,
  init() {
    this.el = document.getElementById('site-header');
    if (!this.el) return;
    this.handleScroll();
    window.addEventListener('scroll', () => this.handleScroll(), {passive: true});
    document.getElementById('mobile-menu-btn')?.addEventListener('click', () => this.openMobileMenu());
    document.getElementById('mobile-menu-close')?.addEventListener('click', () => this.closeMobileMenu());
  },
  handleScroll() {
    this.el.classList.toggle('scrolled', window.scrollY > 10);
  },
  openMobileMenu() {
    document.getElementById('mobile-menu')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  closeMobileMenu() {
    document.getElementById('mobile-menu')?.classList.remove('open');
    document.body.style.overflow = '';
  }
};

// ===== GALLERY =====
const Gallery = {
  init() {
    const thumbs = document.querySelectorAll('.gallery-thumb');
    const mainImg = document.getElementById('gallery-main-img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.full;
        mainImg.srcset = '';
      });
    });
  }
};

// ===== PRODUCT FORM =====
const ProductForm = {
  init() {
    const form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || 1);
      if (!variantId) return;
      const origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Ajout en cours…';
      await Cart.addItem(variantId, qty);
      btn.disabled = false;
      btn.textContent = origText;
    });
    const qtyInput = form.querySelector('.qty-input');
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
    });
    // Sticky ATC
    const stickyAtc = document.getElementById('sticky-atc');
    const atcBtn = document.getElementById('atc-btn');
    if (stickyAtc && atcBtn) {
      new IntersectionObserver(entries => {
        stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
      }, {threshold: 0}).observe(atcBtn);
      document.getElementById('sticky-atc-btn')?.addEventListener('click', () =>
        form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}))
      );
    }
  }
};

// ===== TABS =====
const Tabs = {
  init() {
    document.querySelectorAll('.tab-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        const container = btn.closest('.product-tabs');
        if (!container) return;
        container.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
        container.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        container.querySelector(`[data-tab-content="${target}"]`)?.classList.add('active');
      });
    });
  }
};

// ===== TOAST =====
const Toast = {
  show(msg, type = 'success') {
    let t = document.getElementById('toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.className = `toast toast-${type}`;
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('show')));
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), 3000);
  }
};

// ===== QUICK ADD =====
const QuickAdd = {
  init() {
    document.querySelectorAll('.product-card-quick-add[data-variant-id]').forEach(btn => {
      btn.addEventListener('click', async e => {
        e.preventDefault();
        const orig = btn.textContent;
        btn.textContent = '…';
        await Cart.addItem(btn.dataset.variantId, 1);
        btn.textContent = orig;
      });
    });
  }
};

// ===== ANNOUNCEMENT BAR =====
const AnnouncementBar = {
  init() {
    const bar = document.getElementById('announcement-bar');
    const close = document.getElementById('announcement-close');
    if (!bar || !close) return;
    if (sessionStorage.getItem('announcement-closed')) { bar.style.display = 'none'; return; }
    close.addEventListener('click', () => {
      bar.style.display = 'none';
      sessionStorage.setItem('announcement-closed', '1');
    });
  }
};

// ===== SEARCH =====
const Search = {
  init() {
    const panel = document.getElementById('search-panel');
    if (!panel) return;
    document.querySelectorAll('[data-search-toggle]').forEach(btn =>
      btn.addEventListener('click', () => {
        const open = panel.style.display === 'block';
        panel.style.display = open ? 'none' : 'block';
        if (!open) panel.querySelector('input')?.focus();
      })
    );
    document.getElementById('search-close')?.addEventListener('click', () => panel.style.display = 'none');
    document.addEventListener('keydown', e => { if (e.key === 'Escape') panel.style.display = 'none'; });
  }
};

// ===== INIT =====
document.addEventListener('DOMContentLoaded', () => {
  Cart.init();
  Header.init();
  Gallery.init();
  ProductForm.init();
  Tabs.init();
  QuickAdd.init();
  AnnouncementBar.init();
  Search.init();
});
